export default __webpack_public_path__ + "html-5-logo.png";